import React, { Component } from "react";
import AmazonContent from "./AmazonContent";
import { Form, FormControl } from "react-bootstrap";

class AmazonProducts extends Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row flex-xl-nowrap">
          <div className="col-6 col-md-2 clo-xl-2 bd-sidebar mb-2 border-right border-bottom">
            <Form className="form-center p-2">
              <FormControl type="text" placeholder="Search" className="" />
            </Form>
            <ul>
              <a href="#">test sidebar</a>
            </ul>
            <ul>
              <a href="#">test sidebar</a>
            </ul>
            <ul>
              <a href="#">test sidebar</a>
            </ul>
            <ul>
              <a href="#">test sidebar</a>
            </ul>
            <ul>
              <a href="#">test sidebar</a>
            </ul>
            <ul>
              <a href="#">test sidebar</a>
            </ul>
            <ul>
              <a href="#">test sidebar</a>
            </ul>
            <ul>
              <a href="#">test sidebar</a>
            </ul>
          </div>
          <main
            className="col-12 col-md-9 col-xl-8 py-md-3 pl-md-5 bd-content"
            role="main"
          >
            <AmazonContent />
          </main>
          <div className="col-6 col-md-2 clo-xl-2 mb-2 border-left">
            <h2>Categories</h2>
            <ul>
              <a href="#">Matteress</a>
            </ul>
            <ul>
              <a href="#">DashCam</a>
            </ul>
            <ul>
              <a href="#">Shoes</a>
            </ul>
            <ul>
              <a href="#">Televisions</a>
            </ul>
            <ul>
              <a href="#">Bed Frames</a>
            </ul>
            <ul>
              <a href="#">Books</a>
            </ul>
            <ul>
              <a href="#">Working stations</a>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default AmazonProducts;
